<template>
    <div :class="is_whatsapp_template ? '' : 'message-attachments'">

        <template v-for="attachment in attachments">

            <template v-if="attachment.type == 'image'">

                <!-- Image -->
                <div class="position-relative mb-1 mr-1 d-inline-block" :class="mediaContainer">
                    <a href="#" @click="image_view(attachment)">
                        <b-img-lazy :src="attachment.url.public" class="media-preview p-1" > </b-img-lazy>
                    </a>
                </div>

            </template>

            <template v-else-if="attachment.type == 'video'">

                <template>
                    <!-- Video -->
                    <div class="position-relative mb-1 mr-1 d-inline-block" :class="mediaContainer">
                        <a href="#" @click="video_view(attachment)">
                            <video :src="attachment.url.public" class="media-preview p-1"> </video>
                            <font-awesome-icon :icon="'play-circle'" class="preview-video-button position-absolute p-0" />
                        </a>
                    </div>

                </template>
            </template>

            <template v-else-if="attachment.type == 'gif'">

                <template v-if="attachment.preview">

                    <!-- Video -->
                    <div class="position-relative mb-1 mr-1 d-inline-block" :class="mediaContainer">
                        <a href="#" @click="video_view(attachment)">
                            <video :src="attachment.url.public" class="media-preview p-1"> </video>
                            <font-awesome-icon :icon="'play-circle'" class="preview-video-button position-absolute p-0" />
                        </a>
                    </div>

                </template>
            </template>

            <template v-else-if="attachment.type == 'ptt' || attachment.type == 'audio'">

                <template v-if="attachment.url">
                    <!-- Voice -->
                    <!--                    <a href="#" @click="video_view(attachment)"><b-img :src="attachment.preview.public" class="rounded img-fluid mr-1" /></a>-->
                    <!-- audio element -->
                    <vue-plyr class="audio-player">
                        <audio>
                            <source :src="attachment.url.public" type="audio/ogg" />
                        </audio>
                    </vue-plyr>

                </template>
            </template>

            <template v-else-if="attachment.type == 'pdf'">

                <template v-if="attachment.url">

                    <!-- PDF -->
                    <a :href="attachment.url.public" target="_blank"><b-img src="/images/pdf-icon.png" width="130"
                            class="rounded img-fluid mr-1" /></a>
                </template>
            </template>
          <template v-else-if="attachment.type == 'file'">

            <template v-if="attachment.url">

              <!-- File -->
              <a :href="attachment.url.public" target="_blank"><b-img src="/images/file-icon.png" width="130"
                                                                      class="rounded img-fluid mr-1" /></a>
            </template>
          </template>

            <template v-else-if="attachment.type == 'story_mention'">

                <template v-if="isStoryExpired(attachment) || storyLoadFailed[attachment.id]">
                    <!-- Expired or deleted story -->
                    <div class="story-mention-expired d-inline-flex align-items-center justify-content-center mb-1 mr-1 p-2 rounded border text-muted small">
                        <font-awesome-icon :icon="'clock'" class="mr-1" /> Story expired
                    </div>
                </template>

                <template v-else-if="attachment.content_type && attachment.content_type.startsWith('video')">
                    <!-- Story video -->
                    <div class="position-relative mb-1 mr-1 d-inline-block" :class="mediaContainer">
                        <a href="#" @click="video_view(attachment)">
                            <video :src="attachment.url.public" class="media-preview p-1"
                                @error="markStoryFailed(attachment.id)"></video>
                            <font-awesome-icon :icon="'play-circle'" class="preview-video-button position-absolute p-0" />
                        </a>
                    </div>
                </template>

                <template v-else>
                    <!-- Story image -->
                    <div class="position-relative mb-1 mr-1 d-inline-block" :class="mediaContainer">
                        <a href="#" @click="image_view(attachment)">
                            <b-img-lazy :src="attachment.url.public" class="media-preview p-1"
                                @error.native="markStoryFailed(attachment.id)"></b-img-lazy>
                        </a>
                    </div>
                </template>

            </template>

            <template v-else-if="location">

                <template>

                    <!-- Location -->
                    <a href="#" @click="map_view(location)"><b-img :src="attachment.preview.public"
                            class="rounded img-fluid mr-1" /></a>


                </template>
            </template>

            <template v-else>
                Something coming soon!
            </template>


        </template>

        <template v-if="location">

            <template>

                <!-- Location -->
                <!--                    <a href="#" @click="map_view(location)"><b-img :src="attachment.preview.public" class="rounded img-fluid mr-1" /></a>-->
                <a href="#" @click="map_view(location)">
                    <img class="map_view"
                        :src="'https://maps.googleapis.com/maps/api/staticmap?center=' + location.address + '&zoom=15&size=200x200&maptype=roadmap&markers=color:red%7C' + location.lat + ',' + location.lng + '&key=AIzaSyDpIk7PKY7AM66Pbk7dZT8mOJL7Sdq7fYU'" />
                </a>

            </template>
        </template>

    </div>
</template>


<script>


import ImageView from '../Modal/ImageView.vue';
import VideoView from '../Modal/VideoView.vue';
import MapView from '../Modal/MapView.vue';
import { gmapApi } from 'vue2-google-maps';
import VuePlyr from 'vue-plyr';


import { create } from 'vue-modal-dialogs'

export default {

    components: { gmapApi, VuePlyr },
    props: ['attachments', 'location', 'is_whatsapp_template'],

    mounted: function () {
        // Component mounted
        //console.log('Customer Type Render mounted')
    },

    destroyed() {
        // Component destroyed
        //console.log('Customer Type Render mounted destroyed.');
    },

    created: function () {
        // Component created
    },

    data: function () {

        return {
            // Instagram story mention URLs expire after some time (exact TTL not officially documented).
            // Adjust this value based on observed behavior.
            storyExpiryHours: 24,
            storyLoadFailed: {},
        }

    },

    computed: {

        mediaContainer() {
            if(this.is_whatsapp_template) {
                return 'media-preview-container-header text-center'
            } else {
                return 'media-preview-container'
            }
        }
    },

    methods: {

        getUrl: function (url) {
            console.log(url);
        },

        isStoryExpired: function (attachment) {
            if (!attachment.created_at) return false;
            const diffMs = new Date() - new Date(attachment.created_at);
            return diffMs >= this.storyExpiryHours * 60 * 60 * 1000;
        },

        markStoryFailed: function (attachmentId) {
            this.$set(this.storyLoadFailed, attachmentId, true);
        },

        // Show image
        image_view: async function (attachment) {

            // Show image modal
            const image_view = create(ImageView, 'attachment');

            if (await image_view(attachment)) {
                // Nothing here yet

            }
        },

        // Play video
        video_view: async function (attachment) {

            // Show video modal
            const video_view = create(VideoView, 'attachment');

            if (await video_view(attachment)) {
                // Nothing here yet

            }
        },

        // Show Map
        map_view: async function (location) {

            // Show video modal
            const map_view = create(MapView, 'location');

            if (await map_view(location)) {
                // Nothing here yet

            }
        },

    },

}
</script>